module.exports = __webpack_public_path__ + "img/metrics_grey.55506865.svg";